import React from 'react';
import { ResponseUsers } from "./ImportUsersContainer";
import { Button, LoadingView } from "@cuatroochenta/co-admin-react-library";
import { GetLocale } from "@cuatroochenta/co-admin-react-library";
import { withTranslation, WithTranslation } from "react-i18next";
import { translate } from '../../../I18n/i18n';

interface ImportUsersViewProps extends WithTranslation {
    importUsers: (file: File, stopLoading: () => void) => void
    response: ResponseUsers | null
}

interface state {
    file: File | null
    loading: boolean
}

class ImportUsersView extends React.Component<ImportUsersViewProps> {

    public state: state = { file: null, loading: false };

    private renderFileSelector(): React.ReactNode {

        const { t } = this.props;
        console.log(this.state.file?.name)
        return (
            <div className="col-md-12">
                <label>{translate(t, 'import_user.TR_FILE')}</label>
                <div className="upload-file" style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start'
                }}>
                    {/* Botón personalizado */}
                    <Button
                        className="btn mt-4"
                        onClick={() => {
                            const fileInput = document.getElementById('file-upload');
                            if (fileInput) {
                                (fileInput as HTMLInputElement).click();
                            }
                        }}
                        content={translate(t, 'import_user.TR_SELECT_FILE')}
                    />
                    <input
                        id="file-upload"
                        type="file"
                        className="form-control"
                        onChange={(e) => this.onUploadFile(e.target.files ? e.target.files[0] : null)}
                        disabled={false}
                        title={
                            this.state.file
                                ? this.state.file.name
                                : translate(t, 'import_user.TR_NOT_FILE_SELECTED')
                        }
                        style={{ display: 'none' }}  // Ocultamos el input real
                    />
                    {/* Mostrar el nombre del archivo si se ha seleccionado */}
                    <p style={{paddingLeft: '20px', marginTop: '30px'}}>{this.state.file ? this.state.file.name : t('import_user.TR_NOT_FILE_SELECTED', { lng: GetLocale() })}</p>
                </div>
            </div>
        );
    }

    public onUploadFile(file: File | null): void {
        this.setState({ file: file });
    }


    importUsers(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault()
        if (this.state.file !== null && !this.state.loading) {
            this.setState({ loading: true });
            this.props.importUsers(this.state.file, () => { this.setState({ loading: false }) })
        }
    }

    private renderGenerateButton() {
        return (
            <div className="row">
                <div className="col">
                    <Button
                        type="submit"
                        className="btn mt-4"
                        content={translate(this.props.t, 'import_user.TR_IMPORT_USERS')}
                    />
                </div>
            </div>
        )
    }

    private renderMessageCard() {
        if (this.props.response === null || this.state.loading) {
            return null;
        }

        if (this.props.response.success) {
            return this.renderMessage(this.props.response.message, { color: "green", fontSize: "1.4em", fontWeight: "bold" });
        }

        return this.renderMessage(this.props.response.error, { color: "red" });
    }

    private renderMessage(message: string | null, style: {} = {}) {
        return (
            <div className="col-md-12">
                <div className="card shadow p-3">
                    <div className="card-body">
                        <div className="message">
                            <label style={style}>{message}</label>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    public render() {
        if (this.state.loading) {
            return <LoadingView loading={this.state.loading} />;
        }

        return (
            <div>
                {this.renderMessageCard()}
                <div className="col-md-12">
                    <div className="card shadow p-3">
                        <div className="card-body">
                            <form onSubmit={(e) => this.importUsers(e)}>
                                <div className={"row"}>
                                    {this.renderFileSelector()}
                                </div>
                                {this.renderGenerateButton()}
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withTranslation()(ImportUsersView);